import { Identifiable, Planzone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function getCurrentPlanzone(httpClient: HttpClient) {
  return () =>
    httpClient.sendHttpRequest<Identifiable<Planzone>>({
      endpoint: "/planzones/current",
      method: HttpMethods.GET,
    });
}

export { getCurrentPlanzone };
